import {NavbarComponent} from "../components/body/navbar.component";
import { BannerImageComponent} from "../components/banner.component";
import {ProductsComponent} from "../components/products.component";
import {CategoryComponent} from "../components/category.component";
import {
    AboutComponent,
    ClientComponent,
    InformationComponent
} from "../components/about.component";
import {FooterComponent} from "../components/body/footer.component";
import React, {useEffect, useState} from "react";
import apiJson from "../helper/axios";
import {ProductsExternalSectionComponent, ProductsSectionComponent} from "../components/products-section.component";
import {HomeSEO} from "../helper/seo";
import HelpPopup from "../components/HelperPopUp.component";

function Home(){

    const [products, setProducts] = useState([]);
    const [popularProduct , setPopularProduct] = useState([]);
    const [mdProducts, setMdProducts] = useState([]);
    const [imdProducts, setImdProducts] = useState([]);
    const [anotherProducts,  setAnotherProducts] =  useState([]);

    const [categories, setCategories] = useState([]);

    const getDataProducts = async () => {
        try {
            const response = await apiJson.get("/product/xray");
            setProducts(response?.data?.data?.product?.data || []);
            localStorage.setItem('products', JSON.stringify(response?.data?.data?.product?.data));
            setPopularProduct(response?.data?.data?.popular_product || []);
            setMdProducts(response?.data?.data?.product_type?.xray_series || []);
            setImdProducts(response?.data?.data?.product_type?.vdx_series|| []);
            setAnotherProducts(response?.data?.data?.product_type?.another || []);
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    const getDataCategories = async () => {
        try {
            const response = await apiJson.get("/categories");
            setCategories(response?.data?.data?.categories || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        getDataProducts();
        getDataCategories();
    }, []);


    return(
        <main  >
           <HomeSEO />
            <NavbarComponent />
            <div className={"mt-0"}>
                <BannerImageComponent />
                <ProductsComponent  label={"PRODUK POPULAR"} products={popularProduct} />
                <CategoryComponent categories={categories}/>
                <div className={"pb-10"}>
                    <ProductsSectionComponent title={"X-Ray Inspection"} slug={"model=x-ray-inspection-system-14"} label={"T X /T X R - S E R I E S"} products={mdProducts}/>
                    <ProductsSectionComponent title={"X-Ray VDX"} slug={"model=u-vxd-series-14"} label={"V D X - S E R I E S"} products={imdProducts}/>
                    < ProductsExternalSectionComponent title={"Produk lainnya"} slug={"?model=mkcells-series-11"} label={"I N D U S T R Y"} products={anotherProducts}/>
                </div>
                <AboutComponent />
                <InformationComponent />
                <ClientComponent />
            </div>
            <FooterComponent />
            <HelpPopup />
        </main>
    )
}

export default Home;